export default __webpack_public_path__ + "static/media/emoji-lampe.985b0362.svg";